<template>
    <div  class="is-datetime" :class="dateTimeFormGroup" :id="`datetime-form-group-${_uid}`">
        <label :for="getFieldId" v-if="label && floating == false" v-text="__(label)"></label>
        <input :id="getFieldId" type="text" :placeholder="getLabel" class="form-control" :class="classControl" v-model="datetime">
        <label v-if="label && floating == true" :for="getFieldId" v-text="__(getLabel)"></label>
    </div>
</template>
<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        props: {
            label: {
                type: String,
                required: false,
                default: "Date & Time"
            },
            withTime: {
                type: Boolean,
                required: false,
                default: true,
            },
            inline: {
                required: false,
                type: Boolean,
                default: false,
            },
            format: {
                type: String,
                required: false,
                default: 'Y-MM-DD H:mm:ss Z',
            },
            enableMinDate: {
                type: Boolean,
                required: false,
                default: false,
            },
            mode:{
                type: String,
                required: false,
                default: "single"
            }
        },

        data() {
            return {
                datetime: this.value ? this.value : '',
                calendar: null,
            }
        },

        mounted() {
            this.init();
        },

        methods: {

            init() {
                var options = {
                    static: true,
                    mode: this.mode,
                    altInput: true,
                    time_24hr: false,
                    enableTime: this.withTime,
                    dateFormat: (this.withTime ? 'Y-m-d H:i:S' : 'Y-m-d'),
                    onChange: (selectedDates, dateStr, instance) => {

                        if (this.mode == 'single') {
                            this.$emit('input', moment.tz(dateStr, clientTimeZone).format());
                        }

                        if (this.mode == 'range') {

                            if (dateStr.includes(' to ')) {
                                var data = dateStr.split(' to ')
                                this.$emit('input', {
                                    from: moment.tz(data[0], clientTimeZone).startOf('day').format(),
                                    to: moment.tz(data[1], clientTimeZone).endOf('day').format()
                                })
                            } else {
                                this.$emit('input', {
                                    from: moment.tz(dateStr, clientTimeZone).startOf('day').format(),
                                    to: moment.tz(dateStr, clientTimeZone).endOf('day').format()
                                })
                            }
                        }
                    }
                };

                if (this.enableMinDate) {
                    options['minDate'] = moment().format()
                }

                this.calendar = flatpickr(`#${this.getFieldId}`, options);

                if (this.mode == 'single') {
                    this.calendar.setDate(this.value)
                }
            },

            clear() {
                this.calendar.clear()
            }
        },

        watch: {
            value(val) {
                this.$nextTick(() => {
                    if (this.mode == 'single') {
                        this.calendar.setDate(val)
                    }
                })
            }
        },

        computed: {
            dateTimeFormGroup() {
                return {
                    'is-dirty': !!this.value,
                    'form-label-group': this.floating,
                    'form-group': !this.floating,
                }
            }
        }
    }
</script>
